import { Action } from '@ngrx/store';
import { type } from '../../util/util';
import * as stageTypes from '../../../stage/types';
import * as commonTypes from '../../../shared/types';

export const ActionTypes = {
    GET_STAGE_INFO: type('[Data Stages] Get Stage Information'),
    GET_STAGE_INFO_SUCCESS: type('[Data Stages] Get Stage Information Success'),
    GET_STAGE_INFO_FAIL: type('[Data Stages] Get Stage Information Failure')
};

// Actions for Server Api connection
export class GetStageInfoAction implements Action {
  readonly type = ActionTypes.GET_STAGE_INFO;
  constructor(public payload: {}) {}
}

export class GetStageInfoSuccessAction implements Action {
  readonly type = ActionTypes.GET_STAGE_INFO_SUCCESS;
  constructor(public payload: stageTypes.IStarterResponse) {}
}

export class GetStageInfoFailAction implements Action {
  readonly type = ActionTypes.GET_STAGE_INFO_FAIL;
  constructor(public payload: commonTypes.IErrorResponse<{}>) {}
}


export type Actions
  =
  | GetStageInfoAction
  | GetStageInfoSuccessAction
  | GetStageInfoFailAction;



// WEBPACK FOOTER //
// ./src/app/stateManagement/actions/data/stages.ts